import React from 'react';
import { formatUSDT } from '../../utils/format';

const StatsCards = ({ stats }) => {
  const cards = [
    { label: 'Total Invested', value: formatUSDT(stats.totalInvestment), color: '', icon: '$' },
    { label: 'Active Stake', value: formatUSDT(stats.activeInvestment), color: 'green', icon: '◆' },
    { label: 'Total Earned', value: formatUSDT(stats.totalEarned), color: 'purple', icon: '★' },
    { label: 'Pending Rewards', value: formatUSDT(stats.pendingRewards), color: 'pink', icon: '↑' },
    { label: 'Team Volume', value: formatUSDT(stats.teamVolume), color: '', icon: '⚏' },
    { label: 'Direct Referrals', value: stats.directReferrals?.toString() || '0', color: 'green', icon: '#', raw: true }
  ];

  return (
    <div className="grid grid-3">
      {cards.map((c, i) => (
        <div key={i} className={`stat-card ${c.color}`}>
          <div className="stat-icon">{c.icon}</div>
          <div className="stat-label">{c.label}</div>
          <div className="stat-value stat-value-sm">
            {c.value}
            {!c.raw && <span className="stat-suffix">USDT</span>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
